import React from "react";
import Nav from "./Components/Nav";
import Hero from "./Components/Hero";
import AboutMe from "./Components/AboutMe";
import Projects from "./Components/Projects";
import Marketing from "./Components/Marketing";
import Contact from "./Components/Contact";
import MarketingStack from "./Components/MarketingStack";

const App = () => {
  return (
    <div>
      <div class="hero-bg">
        <Nav />
        <Hero />
      </div>
      <AboutMe />
      <Projects />
      <Marketing />
      <MarketingStack />
      <Contact />
    </div>
  );
};

export default App;
